export const defaultTaxReturnState = {
	TaxReturns: [],
	Total: 0,
	TaxReturnTypeData: []
};

export default {
	...defaultTaxReturnState
};
